import PnmacImage from './Platform/Image';
export default PnmacImage;